<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
  
    <main id="renew2_mypage">
        <div class="top_container renew2_pc">
            <div class="renew2_wrapper renew2_flex">
                <div class="servicelist">
                    <ul class="servicelist__block">
                        <li class="servicelist__item onclick"><a href="/mypage"><img
                                    src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ"><br>マイページ</a></li>
                        <li v-if="false" class="servicelist__item waiting"><a href="/mypage/yagioffer"><img
                                    src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img
                                    src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickemail"><img
                                    src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/introduction" v-if="false"><img
                                    src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                </div>
                <div class="mypage_contents">
                    <h2>基本情報変更</h2>
                    <div class="mypage_contents__01">
                        <div class="change_info">
                            <div class="change_info_mail">
                                <h3>現在のメールアドレス</h3>
                                <br>
                                <ul>
                                  {{$firebase.user.email}}
                                </ul>
                                <br>
                                <h3>変更するメールアドレス</h3>
                                <p>※yagishの全ての機能を利用するためには、必ず受診できるメールアドレスを入力し、確認メールのリンクをクリックしてください。</p>
                                <br>
                                <ul>
                                  <el-input class="input-md" placeholder=""
                                    title="メールアドレス" ref="email" v-model="reconfirmEmail" type="email"></el-input>
                                </ul>
                                <br>
                                <div class="out_block">
                                    <a href="#" @click="mailUpdate()" class="out_btn">メールアドレスの変更</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>


        <!--SP-->
        <div class="top_container renew2_sp">
            <div class="renew2_wrapper">
                <h2>基本情報変更</h2>
                <div class="change_info_mail">
                    <h3>現在のメールアドレス</h3>
                    <br>
                    <ul>
                      {{$firebase.user.email}}
                    </ul>
                    <br>
                    <h3>変更するメールアドレス</h3>
                    <p>※yagishの全ての機能を利用するためには、必ず受診できるメールアドレスを入力し、確認メールのリンクをクリックしてください。</p>
                    <br>
                    <ul>
                      <el-input class="input-md" placeholder=""
                        title="メールアドレス" ref="email" v-model="reconfirmEmail" type="email"></el-input>
                    </ul>
                    <br>
                    <div class="out_block">
                        <a href="#" @click="mailUpdate()" class="out_btn">メールアドレスの変更</a>
                    </div>
                </div>
                <div class="servicelist">
                    <h3>各種サービスのご利用状況</h3>
                    <ul class="renew2_sp_flex servicelist__block">
                        <li v-if="false"><a href="/mypage/yagioffer"><img src="/static/renew2_img/icon_yagioffer.svg"
                                    alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li><a href="/mypage/quickmail"><img src="/static/renew2_img/icon_quickmail.svg"
                                    alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li><a href="/mypage/quickemail"><img src="/static/renew2_img/icon_quickemail.svg"
                                    alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li v-if="false"><a href="/mypage/introduction"><img src="/static/renew2_img/icon_recommend.svg"
                                    alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                </div>
            </div>
            <div class="renew2_sp">
                <a href="/mypage" class="servicelist__mypage"><img src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ">マイページに戻る</a>
            </div>
        </div>

    </main>
    
</div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<style scoped>
</style>



<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      firstStepComplete: false,
      reconfirmEmail: '',
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible:false,
      name:false,
      selectedYagiOfferData:{},
      selectedQuickEmailData:{},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions:{
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code:'',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    getFormatName:function(format_id) {
      for(let p of this.$site.formatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      for(let p of this.$site.keirekishoFormatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      return '-'
    },
    mailUpdate: async function() {
      const app = this
      await this.$firebase.user.updateEmail(app.reconfirmEmail).then(() => {

        const formData = new FormData()
        formData.append('email', app.reconfirmEmail)
        formData.append('uuid', app.$firebase.user.uid)

        app.$axios
          .post(app.$varuna.endPoints.updateEmail, formData, {timeout: 60000})
          .then(function (response) {
          })
          .catch(function (error) {
          }).finally(function () {
          })


        app.$firebase.user.sendEmailVerification().then(() => {
          app.$message({
            duration: 0,
            showClose: true,
            message: 'メールを変更しました。届いた確認メール内のリンクをクリックしてください。',
            type: 'success'
          })
        })
      }).catch((error) => {
        app.$message({
          duration: 0,
          showClose: true,
          message: 'メールを変更に失敗しました。再度ログインしてから試してください。',
          type: 'error'
        })
      })
    }
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) { 
        console.log('logined')
	      this.fullscreenLoading = false

      } else {
        this.$router.push('/login')
      }
    })
  },
  beforeMount: function () {
  },
  destroyed: function () {
  }
}
</script>
